'use client';

import { useEffect } from 'react';
import { getRollbar } from '@/services/rollbar';

const useRollbarError = (error: Error | (null & { digest?: string })) => {
  useEffect(() => {
    const rollbar = getRollbar();
    if (!error || !rollbar) return;

    console.log('Reporting error to Rollbar...');
    rollbar.error(error || {}, undefined, (rollbarError) => {
      if (rollbarError) {
        console.error('Rollbar error reporting failed:');
        console.error(rollbarError);
        return;
      }

      console.log('Reported error to Rollbar');
    });
  }, [error]);
};

export default useRollbarError;
